const translateUserRole = (role: string): string => {
  switch (role) {
    case "admin":
    case "ROLE_ADMIN":
      return "Administrador";
    case "reseller":
    case "ROLE_RESELLER":
      return "Revendedor";
    case "commercial":
    case "ROLE_COMMERCIAL":
      return "Comercial";
    case "user":
    case "ROLE_USER":
      return "Utilizador";
    case "guest":
    case "ROLE_GUEST":
      return "Anónimo";
    default:
      return role;
  }
};

const getUserType = (user: User): string => {
  if (user.type === "admin") {
    return "Administrador";
  }
  if (user.type === "commercial") {
    return "Comercial";
  }
  if (user.type === "reseller") {
    return "Revendedor";
  }
  if (user.type === "user") {
    return "Utilizador";
  }
  return "Anónimo";
};

const isValidUsername = (username: string): boolean => {
  return (username?.length ?? 0) >= 3 && /^[A-Za-z0-9_.]+$/.test(username);
};

const isValidEmail = (email: string): boolean => {
  return !!email?.match(new RegExp("^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+$"));
};

const isValidPassword = (password?: string): boolean => {
  return (password?.length ?? 0) >= 6;
};

const isValidFirstName = (firstName?: string): boolean => {
  return !!firstName && firstName.trim().length > 0;
};

export {
  getUserType,
  translateUserRole,
  isValidUsername,
  isValidEmail,
  isValidPassword,
  isValidFirstName,
};
